import { useState, useEffect } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';

import { RadioOptionsWithConfirm } from 'shared-components';

import { ApplicationState } from '../../../../store';
import { savePI } from '../../../../store/student/actions';
import QuestionPage from '../../../templates/question';
import { Q } from '../../../../store/student/types';
import { InputFieldConfig } from '../../../../types';
import { createUpdatePIFieldAction } from '../../../../store/student/personalInfo/actions';
import { Pages } from '../../../../store/student/personalInfo/types';
import { useCustomNavigate } from '../../../../hooks/useCustomNavigate';

const PersonalQPage8 = () => {
  // dispatch actions
  const dispatch = useDispatch();
  const onNext = (config: any) => {
    dispatch(savePI(Pages.PAGE8, config));
  };
  const onChange = (fieldName: string, value: any, refValue?: any) =>
    dispatch(createUpdatePIFieldAction(fieldName, value, refValue));

  const { navigateToStudentDashboard } = useCustomNavigate();
  const onBackToTaskList = () => navigateToStudentDashboard();

  // state props from store
  // state props from store
  const student = useSelector(({ student }: ApplicationState) => student, shallowEqual);

  const config = useSelector(({ config }: ApplicationState) => config, shallowEqual);

  const {
    WithAgent: withAgentConfig,
  }: {
    WithAgent: InputFieldConfig;
  } = student.config.Checklist.PersonalInfo.Page8;

  const { withAgent = withAgentConfig.defaultValue } = student.personalInfo;

  const [complete, setComplete] = useState(false);

  useEffect(() => {
    setComplete(!withAgentConfig?.visible || !withAgentConfig?.mandatory || withAgent !== '');
  }, [withAgent, withAgentConfig]);

  const { title } = student.config.Checklist.PersonalInfo;
  const currentStep = 8;
  const steps = 10;

  const handleAgentClick = (question: any) => {
    if (question.label === 'No, I did it myself') {
      // NB! label change without running script (script triggers email send)
      onChange(Q.AGENT, 'No');
    } else if (question.label === 'Yes, a school counsellor') {
      onChange(Q.AGENT, 'School');
    } else if (question.label === 'Yes, an agent') {
      onChange(Q.AGENT, 'Agent');
    } else if (question.label === 'Yes, someone else') {
      onChange(Q.AGENT, 'Other');
    }
  };

  return (
    <QuestionPage
      complete={complete}
      currentStep={currentStep}
      steps={steps}
      onNext={() => onNext(config)}
      onBackToTaskList={onBackToTaskList}
      section={title}
    >
      {withAgentConfig?.visible && (
        <RadioOptionsWithConfirm
          key={Q.AGENT}
          id={Q.AGENT}
          label={withAgentConfig?.label}
          inputHelperText={withAgentConfig?.helpText}
          autofocus={true}
          onClick={(question: any) => handleAgentClick(question)}
          questions={[
            {
              char: '1',
              label: 'No, I did it myself',
              selected: withAgent === 'No',
            },
            {
              char: '2',
              label: 'Yes, a school counsellor',
              selected: withAgent === 'School',
            },
            {
              char: '3',
              label: 'Yes, an agent',
              selected: withAgent === 'Agent',
            },
            {
              char: '4',
              label: 'Yes, someone else',
              selected: withAgent === 'Other',
            },
          ]}
        />
      )}
    </QuestionPage>
  );
};

export default PersonalQPage8;
